import { Fragment, type ReactNode } from "react";

/**
 * The port of the $render_text closure the About sections share: plain text
 * where *stars* highlight a phrase and new lines become <br>. Each section
 * passes the utilities for its highlight (text-das-green on all of them so
 * far). Without any, it is plain nl2br(esc_html()).
 *
 * The PHP ran the highlight before nl2br with a pattern that cannot cross a
 * line, so splitting into lines first comes to the same thing.
 */
export function renderText(value: string, highlightClass?: string): ReactNode {
  const lines = value.split(/\r\n|\r|\n/);

  return lines.map((line, lineIndex) => (
    <Fragment key={lineIndex}>
      {lineIndex > 0 && <br />}
      {highlightClass ? highlight(line, highlightClass) : line}
    </Fragment>
  ));
}

function highlight(line: string, className: string): ReactNode {
  const parts = line.split(/\*(.+?)\*/);

  // split() with a capture group alternates plain text and highlighted phrases.
  return parts.map((part, index) =>
    index % 2 ? (
      <span key={index} className={className}>
        {part}
      </span>
    ) : (
      part
    ),
  );
}

/**
 * A reveal delay as PHP echoed the float, so 0.12 + 2 * 0.1 reads "0.32"
 * rather than JavaScript's 0.32000000000000006.
 */
export function revealDelay(seconds: number): string {
  return String(parseFloat(seconds.toPrecision(14)));
}
